// ==========================================
// AGENTINFOSECTION.JSX - AGENT INFO COMPONENT
// Estate Experts Real Estate Website
// Agent information section with images gallery
// ==========================================

import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import '../../../../assets/css/Buyer/Properties/agentInfosection.css'; // CSS file import

function AgentInfo() {
  // ==========================================
  // HANDLER FUNCTION
  // ==========================================
  
  // Navigate to agents page
  const handleAgentsClick = () => {
    // Navigate to agents page
    window.location.href = '/agents';
    // Or use React Router: navigate('/agents');
  };

  // ==========================================
  // RENDER
  // ==========================================
  
  return (
    <section className="agent-info-section">
      <div className="agent-info-container">
        
        {/* ==========================================
            LEFT SIDE - Text Content
            ========================================== */}
        <div className="agent-info-left">
          
          {/* Main Heading */}
          <h2 className="agent-info-heading">
            Bringing Local Expertise to Every Real Estate Journey
          </h2>
          
          {/* Description Text */}
          <p className="agent-info-description">
            We believe that real estate is more than just buying or selling properties—it's about helping 
            people build their futures. With years of experience, an in-depth understanding of the market, 
            and a commitment to excellence, we provide tailored solutions to meet your unique needs. 
            Let us guide you every step of the way as you embark on your next chapter.
          </p>
          
          {/* Agents Button */}
          <button 
            className="agents-btn"
            onClick={handleAgentsClick}
          >
            <span>Agents</span>
            <FaArrowRight className="btn-arrow" />
          </button>
        </div>

        {/* ==========================================
            RIGHT SIDE - Images Gallery
            3 images: small, large (center), small
            ========================================== */}
        <div className="agent-info-right">
          
          {/* Left Small Image */}
          <div className="agent-image agent-image-small agent-image-left">
            <img 
              src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400&h=600&fit=crop&q=80" 
              alt="Real Estate Property 1"
              className="gallery-img"
            />
          </div>
          
          {/* Center Large Image */}
          <div className="agent-image agent-image-large">
            <img 
              src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=600&h=600&fit=crop&q=80" 
              alt="Real Estate Property Featured"
              className="gallery-img"
            />
          </div>
          
          {/* Right Small Image */}
          <div className="agent-image agent-image-small agent-image-right">
            <img 
              src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=400&h=600&fit=crop&q=80" 
              alt="Real Estate Property 2"
              className="gallery-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AgentInfo;